document.addEventListener("DOMContentLoaded", function () {
  // トップスライダーの起動
  if (document.querySelectorAll(".swiper_top").length > 0) {
    const swiper = new Swiper(".swiper_top", {
      speed: 1000, // スライド変化時間
      loop: true,
      slidesPerView: 1.4,
      spaceBetween: 10,
      centeredSlides: true,
      autoplay: {
        delay: 4000, //　スライダー表示時間
        disableOnInteraction: false,
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        afterInit: function () {
          setTimeout(function () {
            document.querySelector(".swiper_top").classList.add("swiper_top_on");
          }, 1000);
        },
      },
      breakpoints: {
        769: {
          slidesPerView: 2.2,
          spaceBetween: 40,
        },
      },
    });
  }

});
